import { Users, UtensilsCrossed, MapPin, Waves } from "lucide-react";
import { Reveal } from "./Reveal";
import { IconBadge } from "./IconBadge";

const POINTS = [
  {
    icon: Users,
    title: "Your group, and no one else's",
    text: "Each villa sleeps 12 + 2 guests across six private bedrooms. The whole group under one roof.",
  },
  {
    icon: UtensilsCrossed,
    title: "Meals taken care of",
    text: "Breakfast and dinner are included with every stay. Lunch and a safari experience can be added.",
  },
  {
    icon: MapPin,
    title: "Close to the city, far from its pace",
    text: "Set within Area 83, off Bannerghatta Road. A short drive that feels nothing like the city.",
  },
  {
    icon: Waves,
    title: "Room to slow down",
    text: "A swimming pool, a full kitchen, generous living spaces and free on-site parking.",
  },
];

export const WhyDune = () => (
  <section data-testid="why-section" className="bg-brand-ivory py-20 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <Reveal className="mb-12 max-w-2xl lg:mb-16">
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand-moss">Why Dune Villas</p>
        <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-brand-licorice sm:text-5xl">
          Premium, private, and easy to reach
        </h2>
      </Reveal>
      <div className="grid gap-y-8 sm:grid-cols-2 sm:gap-x-10 sm:gap-y-12 lg:grid-cols-4">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div data-testid={`why-point-${i + 1}`} className="flex gap-5 border-t border-brand-licorice/15 pt-6 sm:flex-col sm:pt-7">
              <IconBadge icon={p.icon} delay={i * 0.08} />
              <div>
                <h3 className="font-serif text-2xl font-light leading-snug text-brand-licorice">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-licorice/65">{p.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
